'use client'

import type { FaqMetadataProps } from '@maestro/commerce-blocks/components/metadata/metadata.types'

import {
  extractTextFromBlocks,
  omitEmpty,
} from '@maestro/commerce-blocks/components/metadata/helpers'

export function FaqStructuredData(props: FaqMetadataProps) {
  const { groups } = props

  const structuredData = omitEmpty({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: groups?.map((group) => ({
      '@type': 'Question',
      name: group.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: extractTextFromBlocks(group.content),
      },
    })),
  })

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  )
}
